import ScrollInAnimationItem from '../../../components/scrollInAnimationItem/ScrollInAnimationItem';
import { ScrollAnimationType } from '../../../enums/scroll-animation-type.enum';

import styles from './AboutTextBox.module.scss';

interface IAboutTextBoxProps {
  content: JSX.Element;
  caption: JSX.Element;
  animationType?: ScrollAnimationType;
  dark?: boolean;
  className?: string;
  captionDelay?: string;
  contentDelay?: string;
}

const AboutTextBox = ({
  content,
  caption,
  className,
  dark,
  captionDelay = '0.3s',
  contentDelay = '0.4s',
}: IAboutTextBoxProps) => {
  return (
    <div className={`${className} ${styles['box']} ${dark ? styles['box--dark'] : ''}`}>
      <div className={styles['border--top']}></div>
      <div className={styles['wrapper']}>
        <ScrollInAnimationItem delay={captionDelay} threshold={1}>
          <h2 className={styles['caption']}>{caption}</h2>
        </ScrollInAnimationItem>
        <ScrollInAnimationItem delay={contentDelay} threshold={0.3}>
          <div className={styles['content']}>{content}</div>
        </ScrollInAnimationItem>
      </div>
      <div className={styles['border--bottom']}></div>
    </div>
  );
};

export default AboutTextBox;
